import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { CheckboxTableRow, ExTable, SelectionFixedFooter, TableBody, TableHead, TableWrapper, useMultipleCheckForm } from 'components/shared/widget'
import { useDownloadSampleListApi, useFetchDetailSamplesApi } from 'api/sample'
import { Sample, SampleSearchForm } from 'entities/sample'
import { Pagination } from 'components/shared/pagination'
import { useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { DisplaySetting, DisplaySettingModal, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { MasterDataContext } from 'contexts/master_data_context'
import { TranscriptionForm } from 'components/shared/type'
import { Flex } from 'components/shared/flex'
import { useFetchProductItemsApi } from 'api/product_item'
import { ProductItemSearchForm } from 'entities/product_item'
import { analyticsSampleColumnInfoList, AnalyticsSampleTableData } from './analytics_sample_table'
import { Button } from 'react-bootstrap'

type Props = {
    history: H.History
}

const SamplesPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<SampleSearchForm>()
    const searchForm = useForm<SampleSearchForm>({ ...query, ordering: 'sample_created_at' })
    const api = useFetchDetailSamplesApi(searchForm)
    const checkIdForm = useMultipleCheckForm<Sample>()
    const productForm = useForm<ProductItemSearchForm>({ scope: 'all' })
    const productApi = useFetchProductItemsApi(productForm)
    const sampleDisplaySetting = useDisplaySetting(
        analyticsSampleColumnInfoList(
            searchForm,
            productApi.response.results.map((pi) => {
                return { label: pi.name, value: pi.id! }
            })
        ),
        'Sample'
    )
    const displaySettings: DisplaySetting[] = [sampleDisplaySetting]
    const masterData = useContext(MasterDataContext)
    const transcriptionForm = useForm<TranscriptionForm>({ items: [] })
    const [showToExtModal, setShowToExtModal] = useState<boolean>(false)
    const [search, setSearch] = useState<string | undefined>()
    const downloadApi = useDownloadSampleListApi(searchForm)

    useEffect(() => {
        api.execute()
        productApi.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof SampleSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        transcriptionForm.updateObject(
            'items',
            checkIdForm.form.object.items.map((item) => {
                return { id: item.code, count: 1 }
            })
        )
    }, [checkIdForm.form.object])

    const handleClickToExt = (): void => {
        setShowToExtModal(true)
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`analytics_samples?${queryParams}`)
        }
    }, [searchForm.object])

    return (
        <>
            <ContentHeader
                headerTitle="検体情報"
                left={
                    <>
                        <SearchConditionView
                            searchForm={searchForm}
                            onClickRemoveButton={handleClickRemoveFilter}
                            hiddenSearchParams={['sampleStatus', 'institutionId']}
                        />
                    </>
                }
                right={
                    <>
                        <Button
                            variant="success"
                            onClick={() => {
                                downloadApi.execute()
                            }}
                        >
                            Excel DL
                        </Button>
                        <DisplaySettingModal displaySettings={displaySettings} />
                    </>
                }
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center"></Flex>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response} searchForm={searchForm}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={checkIdForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={checkIdForm} showEdit>
                                <TableHeads displaySetting={sampleDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={sampleDisplaySetting.getColumnLength() + 1}>
                            {api.response.results.map((sample: Sample) => {
                                return (
                                    <CheckboxTableRow key={`sample-${sample.id}`} item={sample} multipleCheckForm={checkIdForm}>
                                        <AnalyticsSampleTableData sample={sample} displaySetting={sampleDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response} searchForm={searchForm}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={checkIdForm.ids()}
                onClickReset={() => checkIdForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="sampleIdIn"
                tableName="Sample"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(SamplesPage)
